import React from 'react';
import { withRouter } from 'react-router-dom';

import PropTypes from 'prop-types';

// COMPONENTS
import Error from '../../components/Error/Error';
import { isBrandRefreshEnabled } from '../../shared/utilities/brandRefresh';
import BrandRefreshNotFound from '../SecondaryPages/BrandRefreshNotFound';

const NoMatch = () => {
  return isBrandRefreshEnabled() ? <BrandRefreshNotFound /> : <Error errorType="404" />
};

NoMatch.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
}

export default withRouter(NoMatch);
